import { ApiResponse } from '../types';

const BASE_URL = '/api';

async function request<T>(endpoint: string, options?: RequestInit): Promise<ApiResponse<T>> {
  let response: Response;

  try {
    response = await fetch(`${BASE_URL}${endpoint}`, {
      ...options,
      headers: {
        Accept: 'application/json',
        ...options?.headers,
      },
    });
  } catch {
    return {
      success: false,
      error: 'Keine Verbindung zum Server. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
      error_code: 'NETWORK_ERROR',
    };
  }

  try {
    const payload = await response.json() as ApiResponse<T>;
    if (!response.ok || !payload.success) {
      return {
        ...payload,
        success: false,
        error: payload.error || 'Die Anfrage konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.',
        error_code: payload.error_code || 'REQUEST_FAILED',
      };
    }
    return payload;
  } catch {
    return {
      success: false,
      error: 'Der Server hat eine ungültige Antwort gesendet. Bitte versuchen Sie es später erneut.',
      error_code: 'INVALID_RESPONSE',
    };
  }
}

export function post<T>(endpoint: string, body: unknown): Promise<ApiResponse<T>> {
  return request<T>(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export function get<T>(endpoint: string): Promise<ApiResponse<T>> {
  return request<T>(endpoint);
}
